import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

import { UserContext } from '../../contexts';
import { MerchantsList } from '../organisms';

export function MerchantsPage() {
  const { user } = useContext(UserContext);

  // CORRECT use of `is_dao_admin` (= `is_admin && !is_merchant`): keeps merchants
  // out of the merchant directory. The list itself (/api/merchants) is
  // store-scoped server-side via UserSearchService::searchMerchants() +
  // applyStoreIdMConstraint(), so a tenant admin sees only their own store's
  // merchants — no cross-tenant read to close. Must stay in step with the
  // "Merchants" tab in views/Users/UsersTabs.jsx.
  if (!user.is_dao_admin) {
    return <Redirect to="/error/403" />
  }

  return (
    <MerchantsList />
  );
}
